'use client'
import {Splide, SplideSlide, SplideTrack} from "@splidejs/react-splide";
import Image from 'next/image'
import '@splidejs/react-splide/css';
import './Carousel.scss';
import arrowRight from '../../assets/images/icons/arrowRight.svg';
import arrowLeft from '../../assets/images/icons/arrowLeft.svg';
import {useEffect, useRef} from "react";

function Carousel({data, sliderOptions, className, CardComponent, customCardClass}) {
    const carouselRef = useRef(null);

    useEffect(() => {
        const handleMove = () => {
            const inputs = document.querySelectorAll('input');
            inputs.forEach(input => input.blur());
        };

        const splide = carouselRef.current?.splide;

        if (splide) {
            splide.on('drag', handleMove);
        }

        // Cleanup event listener on component unmount
        return () => {
            if (splide) {
                splide.off('drag', handleMove);
            }
        };
    }, []);

    return (
        <>
            <Splide ref={carouselRef} hasTrack={false} className={className} options={sliderOptions} aria-label="My Favorite Images">
                <SplideTrack>
                    {data.map((item, index) => {
                        return (
                            <SplideSlide key={index}>
                                <CardComponent className={customCardClass} item={item}/>
                            </SplideSlide>
                        )
                    })}
                </SplideTrack>
                <div className="splide__arrows">
                    <button className="splide__arrow splide__arrow--prev">
                        <Image src={arrowLeft} alt={'arrowRight'}/>
                    </button>
                    <button className="splide__arrow splide__arrow--next">
                        <Image src={arrowRight} alt={'arrowLeft'}/>
                    </button>
                </div>
            </Splide>
        </>
    );
}

export default Carousel;